module.exports = __webpack_public_path__ + "static/media/waves.df9dd139.svg";